import { render, staticRenderFns } from "./EventsWrapper.vue?vue&type=template&id=3d8e4230&"
import script from "./EventsWrapper.vue?vue&type=script&lang=js&"
export * from "./EventsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./EventsWrapper.vue?vue&type=style&index=0&id=3d8e4230&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports